import { c as _c } from "react/compiler-runtime";
import { ThemedLogoFpMark } from '@onefootprint/icons';
import { motion, useReducedMotion } from 'framer-motion';
import { useEffect, useState } from 'react';
const TIPS = ['You can ask me to pull up any user by email or phone number', 'Try asking me to summarize a recent onboarding session', 'You can ask me to compare two users side by side', 'Ask me to find patterns across recent failed verifications', 'You can ask me to explain why a specific decision was made', 'Try asking me to flag anything unusual in the last 24 hours', 'You can ask me questions in plain English — no special syntax needed', 'Ask me to draft a response to a support ticket', 'You can bulk create investigations by uploading a CSV of data', 'Ask me to show recent high-risk users that need review', 'Try asking me which onboarding step is blocking a user', 'Ask me to open the latest investigation for a user', 'You can ask me to look up users with duplicate signals', 'Try asking me to list users missing required documents'];
const shuffleTips = () => {
  const tips = [...TIPS];
  for (let i = tips.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [tips[i], tips[j]] = [tips[j], tips[i]];
  }
  return tips;
};
const ThinkingIndicator = () => {
  const $ = _c(14);
  const [tips] = useState(shuffleTips);
  const [tipIndex, setTipIndex] = useState(0);
  const [showTip, setShowTip] = useState(false);
  const shouldReduceMotion = useReducedMotion();
  let t0;
  let t1;
  if ($[0] !== tips.length) {
    t0 = () => {
      const interval = setInterval(() => {
        setShowTip(prev => {
          if (prev) {
            setTipIndex(i => (i + 1) % tips.length);
          }
          return !prev;
        });
      }, 3000);
      return () => clearInterval(interval);
    };
    t1 = [tips.length];
    $[0] = tips.length;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== shouldReduceMotion) {
    t2 = shouldReduceMotion ? undefined : {
      opacity: [0.35, 1, 0.35]
    };
    $[3] = shouldReduceMotion;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 2,
      repeat: Number.POSITIVE_INFINITY,
      ease: "easeInOut"
    };
    t4 = <ThemedLogoFpMark className="size-[18px]" color="primary" />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2) {
    t5 = <motion.div animate={t2} transition={t3}>{t4}</motion.div>;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = showTip ? `Tip: ${tips[tipIndex]}` : "Thinking...";
  let t7;
  if ($[9] !== t6) {
    t7 = <span className="text-caption-1 text-shimmer max-md:min-w-0 max-md:truncate">{t6}</span>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <div className="flex items-center gap-2 py-2" aria-live="polite">{t5}{t7}</div>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default ThinkingIndicator;